const cardsOptions =
	{
		name: {
			first: 'РІК ГІГАБІТУ',
		},
		headerColor: '#ff5f55',
		advantages: [
			{
				icon: require('../../assets/gigabit-year/icons/network.png'),
				text: '1000 Мбіт/c',
			},
			{
				icon: require('../../assets/gigabit-year/icons/promo.png'),
				text: 'Акційне підключення'
			},
			{
				icon: require('../../assets/gigabit-year/icons/tech.png'),
				text: 'Технічна підтримка 24/7'
			}
		],
		texts: {
			main: {
				text: '<b>1099</b>&nbsp;грн&nbsp;/&nbsp;<b>1</b>&nbsp;рік',
				color: '#ff4a3f'
			},
			second: {
				text: 'Вартість 1099 грн <br>12 міс. інтернету (1Гбіт/с), підключення 1 грн',
				color: '#6a6a6a'
			},
		}
	}

export default cardsOptions